import { intcmp } from 'utils/string'

import { pathTo } from 'libreon/routes'

/*
Challenges are recursive.

You have links of Challenges and challenges can have links of challenges.
*/
function normalizeChallengeLink({ id: linkId, order, challenge, challengeId }) {
  return Object.freeze({
    // we get id from the challenge, unless it's just a ref with challengeId,
    id: challengeId,
    ...normalizeChallenge(challenge),
    linkId,
    order
  })
}

export function normalizeChallenge(challenge, depth) {
  if (!challenge) return {}
  const {
    id,
    name = undefined,
    rname = undefined,
    explain = undefined,
    visible = undefined,
    context = undefined,
    links = [],
    triggers = [],
    conditions = undefined,
    actions = undefined,
    completed = undefined,
    journal = undefined,
    meta = undefined,
    originId = undefined,
    originType = undefined,
    originKey = undefined
  } = challenge

  return Object.freeze({
    id,
    name, // : interpolateName(challenge.name, "_"),
    rname,
    milestoneId: meta?.milestone_id,
    explain,
    visible,
    context,
    triggers,
    conditions,
    actions,
    completed,
    journal,
    meta,
    originId,
    originType,
    originKey,
    ...normalizeChallengeLinks(links, depth + 1)
  })
}

export function normalizeChallengeLinks(links = [], depth = 0) {
  if (depth > 100) {
    throw new Error('Too deep of challenge links')
  }

  const cLinksD = links.reduce((cLinksD, link) => {
    // because id changes, do this in two steps
    link = normalizeChallengeLink(link, depth)
    cLinksD[link.id] = link
    return cLinksD
  }, {})
  const cLinksL = Object.values(cLinksD)
    .toSorted((a, b) => intcmp(a.order, b.order))
    .map((l) => l.id)
  return { cLinksD, cLinksL }
}

////////////////////////////////////////////////////////////////////////////////
// this comes in from a direct call to reactorChallenges()
export function normalizeChallenges(challenges, milestonesD, projectId) {
  console.log('normalizeChallenges', { challenges, milestonesD, projectId })
  const challengesD = challenges.reduce((challengesD, challenge) => {
    challenge = { ...normalizeChallenge(challenge) }
    challenge.name = console.inspect(interpolateName(challenge.name, projectId))
    challengesD[challenge.id] = Object.freeze(challenge)
    return challengesD
  }, {})

  const top = Object.keys(challengesD).reduce(
    (top, cId) => {
      return challengesD[cId].cLinksL.reduce((top, id) => {
        delete top[id]
        return top
      }, top)
    },
    { ...challengesD }
  )

  let challengesL = Object.keys(top).reduce((challengesL, id) => {
    if (challengesD[id].visible) {
      return challengesL.concat(id)
    }
    return challengesL.concat(challengesD[id].cLinksL)
  }, [])

  challengesL = Array.from(new Set(challengesL)).toSorted((b, a) =>
    intcmp(challengesD[b]?.order || 0, challengesD[a]?.order || 0)
  )

  return { challengesD, challengesL }
}

////////////////////////////////////////////////////////////////////////////////
function interpolateName(name, projectId) {
  console.log('interpolateName', { name })
  return name.replace(/(\${link:([^}]+)})/g, (a, b, c) =>
    interpolateLookup(c, projectId)
  )
}

function interpolateLookup(token, projectId) {
  const [type, ...rest] = token.split(':')
  switch (type) {
    case 'files':
      return pathTo('project_files', { projectId })
    case 'topics':
      return pathTo('project', { projectId })
    case 'members':
    case 'invite': // this goes away
      return pathTo('project_members', { projectId })
    case 'profile':
      return pathTo('project_edit', { projectId })
    // case 'goals':
    //   return pathTo('project_goals', projectId}/goals`
    // not map?
    case 'challengeInput': {
      const [jmId] = rest
      // if (qId) {
      //   return pathTo('project_xhallenge_input_group', {projectId, groupId: jmId}) // todo: qId
      // } else {
      return pathTo('project_edit_xhallenge_input_group', {
        projectId,
        groupId: jmId
      })
      // }
    }

    default:
      return 'bad link'
  }
}
